import { ajaxRequest, getActionAjax } from "@comact/crc";
import { IFeatureFlag } from "./model";
import slice from "./slices";

export const getFeatureFlags = getActionAjax((nodeId: string) => (dispatch) => (
    ajaxRequest({
        serverLessResolve: () => import("./mocks").then((m) => m.getFeatureFlags()),
        url: `/api/v1/config/flags/${nodeId}`,
        onSuccess: (flags: IFeatureFlag[]) => {
            dispatch(slice.actions.set(flags));
        },
    })
));